import { DecimalPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import { OrderHelper } from '../../dashboard/orders/common/helpers/order.helper';
import type { OrderLoadingGood } from '../../dashboard/orders/common/interfaces/order-point';

@Pipe({
  name: 'goodQuantity',
})
export class GoodQuantityPipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);
  private readonly translateService = inject(TranslateService);

  public transform(good: OnyxOptional<OrderLoadingGood>): string {
    if (!good) return '-';

    const decimalPlaces = OrderHelper.getGoodSizeDecimalPlaces(good.size?.type);
    const quantity = this.decimalPipe.transform(
      (OrderHelper.getGoodQuantity(good) ?? 0) / 10 ** decimalPlaces,
      `1.0-2`,
    );

    return `${quantity} ${this.translateService.instant(OrderHelper.getGoodUnit(good.size?.type))}`;
  }
}
